// extracted by mini-css-extract-plugin
export default {"main":"main_main__jk1i9","content":"main_content__7UiFI","aboutText":"main_aboutText__SnNVk","info":"main_info__zhyXz","img":"main_img__BwoLL","head":"main_head__OWa+6"};